import React from 'react'
import styled from 'styled-components'

const AllBooksCard = ({link, isbn, author, title, journal, pubdate }) => {
  return (
    <Container>
        <NVLContainer>
            <p>NVL</p>
        </NVLContainer>

        <BookDetails>
            <a href={link} target='_blank' >{title}</a>
            <p>ISBN Number: <span>{isbn}</span> </p>
            <p>Author: <span>{author}</span> </p>
            <p>Journal: <span>{journal}</span> </p>
            <p> Date Published: <span>{pubdate}</span> </p>
        </BookDetails>
    </Container>
  )
}

const Container = styled.section`
    display: flex;
    flex-direction: row;
    padding: 50px 25px;
    padding-bottom: 25px;
    /* align-self: flex-start; */
    width: 100%;
    border-bottom: 2px solid #000;

    @media screen and (max-width: 600px){
        padding: 30px 15px;
        padding-bottom: 15px;
    }

`

const NVLContainer = styled.div`
    border: 1px solid #e5e5e5;
    padding: 8px;
    text-align: center;
    width: fit-content;
    height: fit-content;
    border-radius: 5px;
    font-weight: 600;
`

const BookDetails = styled.div`
    padding-left: 15px;

    & > a{
        color: #005EA2;
        font-weight: 600;
        font-size: 24px;
        @media screen and (max-width: 600px){
            font-size: 20px;
        }
    }

    & > p{
        font-weight: 600;
        margin-top: 8px;
        @media screen and (max-width: 600px){
            font-size: 14px;
        }

        & > span{
            font-weight: 400;
        }
    }
`

export {AllBooksCard}